import { Translations } from './index';

export const frCA: Translations = {
  app: {
    name: 'Chercheur d\'Événements',
    tagline: 'Découvrez des Événements dans le Monde Entier',
    description: 'Découvrez les événements d’organisations, d’universités et de villes grâce à la recherche alimentée par l’IA',
  },

  header: {
    searchPlaceholder: 'Rechercher des événements, sujets ou lieux...',
    searchingEvents: 'Recherche d\'événements...',
    noSuggestionsFound: 'Aucune suggestion trouvée',
    searchButton: 'Rechercher',
    categoriesView: 'Catégories',
    mapView: 'Événements près de moi',
    calendarView: 'Vue Calendrier',
    feedback: 'Commentaires',
    createGroup: 'Créer des groupes d’événements',
    myEvents: 'Mes événements',
    menu: 'Menu',
    howItWorks: 'Comment ça fonctionne',
    latestUpdates: 'Dernières mises à jour',
    upcomingShort: 'à venir',
  },

  suggestions: {
    locations: 'Lieux',
    entities: 'Entreprises technologiques, sociétés, universités et organisations',
    events: 'Événements',
    location: 'Lieu',
    relevance: 'Pertinence',
  },

  homepage: {
    heroTitle: 'Découvrez des Événements Extraordinaires',
    heroSubtitle: 'Trouvez et explorez des événements qui correspondent à vos intérêts avec notre recherche alimentée par l\'IA',
    popularEvents: 'Événements populaires',
    topCities: 'Villes Principales',
    viewAllEvents: 'Voir Tous les Événements',
    exploreEvents: 'Explorer les Événements',
    discoverEvents: 'Découvrir les Événements',
    findEventsNearby: 'Trouver des Événements à Proximité',
    liveStats: {
      ariaLabel: 'Activité actuelle d’Event Finder',
      upcoming: 'À venir',
      inPerson: 'En personne',
      virtual: 'Virtuels',
      hybrid: 'Hybrides',
      organizations: 'Organisations',
      partners: 'entreprises technologiques',
      companies: 'sociétés',
      webSources: 'Sources web',
      cities: 'villes',
      countries: 'pays',
      continents: 'continents',
      addedPastWeek: 'ajoutés en 7 jours',
      updated: 'Mis à jour',
      fresh: 'Données récentes',
      loading: 'Chargement de l’activité',
    },
  },

  events: {
    upcoming: 'À venir',
    past: 'Passé',
    virtual: 'Virtuel',
    inPerson: 'En personne',
    free: 'Gratuit',
    paid: 'Payant',
    eventDetails: 'Détails de l\'événement',
    venue: 'Lieu',
    date: 'Date',
    time: 'Heure',
    location: 'Emplacement',
    organizer: 'Organisateur',
    category: 'Catégorie',
    register: 'S\'inscrire',
    moreInfo: 'Plus d\'infos',
    noEventsFound: 'Aucun événement trouvé',
    loadingEvents: 'Chargement des événements...',
    relatedTo: 'Lié à',
    duration: 'Durée',
    eventSource: 'Source de l\'événement',
    universityHosted: 'Organisé par une université',
    universityFallbackName: 'une université',
    universityAttendanceNotice: 'Cet événement est organisé par {university}. Les événements universitaires peuvent être soumis à des restrictions de présence ou d’admissibilité. Vérifiez la page de l’événement ou les détails d’inscription avant de vous présenter.',
    universityCampusPrecision: 'niveau du campus (université hôte)',
  },

  browse: {
    title: 'Parcourir les Événements',
    searchResultsTitle: 'Résultats de recherche pour "{query}"',
    searchResultsDescription: 'Découvrez des événements liés à "{query}" grâce à la recherche alimentée par IA',
    noResultsTitle: 'Aucun événement trouvé',
    noResultsDescription: 'Essayez d\'ajuster vos critères de recherche ou filtres',
    showingResults: 'Affichage de {count} sur {total} événements',
    filtersApplied: 'Filtres appliqués',
  },

  map: {
    title: 'Événements près de moi',
    subtitle: 'Explorez les événements à travers le monde',
    eventsNearby: 'Événements à Proximité',
    showingEvents: 'Affichage des événements',
    zoomToArea: 'Zoomer sur la zone',
    currentLocation: 'Emplacement Actuel',
    enableLocation: 'Activer l\'Emplacement',
    failedToLoadEvents: 'Échec du chargement des événements. Veuillez réessayer plus tard.',
    failedToGetLocation: 'Impossible d\'obtenir votre emplacement. Veuillez activer les services de localisation.',
  },

  calendar: {
    title: 'Calendrier d\'Événements',
    subtitle: 'Voir les événements par date',
    monthView: 'Vue Mensuelle',
    weekView: 'Vue Hebdomadaire',
    dayView: 'Vue Quotidienne',
    today: 'Aujourd\'hui',
    nextMonth: 'Mois Suivant',
    previousMonth: 'Mois Précédent',
    eventsToday: 'Événements Aujourd\'hui',
    noEventsThisDay: 'Aucun événement prévu pour ce jour',
  },

  filters: {
    filterBy: 'Filtrer Par',
    dateRange: 'Plage de Dates',
    location: 'Lieu',
    category: 'Catégorie',
    price: 'Prix',
    eventType: 'Type d\'Événement',
    clearFilters: 'Effacer les Filtres',
    applyFilters: 'Appliquer les Filtres',
    startDate: 'Date de Début',
    endDate: 'Date de Fin',
    anyPrice: 'Tout Prix',
    freeOnly: 'Gratuit Seulement',
    paidOnly: 'Payant Seulement',
    anyType: 'Tout Type',
    virtualOnly: 'Virtuel Seulement',
    inPersonOnly: 'En Personne Seulement',
  },

  actions: {
    search: 'Rechercher',
    clear: 'Effacer',
    cancel: 'Annuler',
    save: 'Sauvegarder',
    edit: 'Modifier',
    delete: 'Supprimer',
    share: 'Partager',
    export: 'Exporter',
    print: 'Imprimer',
    refresh: 'Actualiser',
    back: 'Retour',
    next: 'Suivant',
    previous: 'Précédent',
    close: 'Fermer',
    submit: 'Soumettre',
  },

  time: {
    today: 'Aujourd\'hui',
    tomorrow: 'Demain',
    yesterday: 'Hier',
    thisWeek: 'Cette Semaine',
    nextWeek: 'Semaine Prochaine',
    thisMonth: 'Ce Mois',
    nextMonth: 'Mois Prochain',
    morning: 'Matin',
    afternoon: 'Après-midi',
    evening: 'Soir',
    night: 'Nuit',
    days: {
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche',
    },
    months: {
      january: 'Janvier',
      february: 'Février',
      march: 'Mars',
      april: 'Avril',
      may: 'Mai',
      june: 'Juin',
      july: 'Juillet',
      august: 'Août',
      september: 'Septembre',
      october: 'Octobre',
      november: 'Novembre',
      december: 'Décembre',
    },
  },

  errors: {
    general: 'Une erreur s\'est produite. Veuillez réessayer.',
    networkError: 'Erreur réseau. Veuillez vérifier votre connexion.',
    notFound: 'L\'élément demandé n\'a pas été trouvé.',
    unauthorized: 'Vous n\'êtes pas autorisé à accéder à cette ressource.',
    serverError: 'Erreur du serveur. Veuillez réessayer plus tard.',
    invalidInput: 'Entrée invalide. Veuillez vérifier vos données.',
    tryAgainLater: 'Veuillez réessayer plus tard.',
    pageNotFound: 'Page non trouvée.',
    locationError: 'Impossible d\'accéder à votre emplacement.',
  },

  success: {
    eventSaved: 'Événement sauvegardé avec succès !',
    filtersSaved: 'Filtres sauvegardés avec succès !',
    settingsUpdated: 'Paramètres mis à jour avec succès !',
    feedbackSubmitted: 'Commentaires soumis avec succès !',
  },

  loading: {
    general: 'Chargement...',
    events: 'Chargement des événements...',
    suggestions: 'Chargement des suggestions...',
    map: 'Chargement de la carte...',
    calendar: 'Chargement du calendrier...',
    searching: 'Recherche...',
  },

  categories: {
    technology: 'Technologie',
    business: 'Affaires',
    education: 'Éducation',
    healthcare: 'Soins de Santé',
    entertainment: 'Divertissement',
    sports: 'Sports',
    arts: 'Arts',
    science: 'Science',
    community: 'Communauté',
    networking: 'Réseautage',
    conference: 'Conférence',
    workshop: 'Atelier',
    seminar: 'Séminaire',
    meetup: 'Rencontre',
    webinar: 'Webinaire',
  },

  footer: {
    companyName: 'Event Finder',
    companyDescription: 'Découvrez et connectez-vous avec des événements extraordinaires à travers le monde. Des rencontres locales aux conférences internationales, nous vous aidons à trouver des expériences qui vous importent.',
    contactEmail: 'bonjour@eventfinder.site',
    contactPhone: '+1 (555) 123-EVENT',
    contactAddress: 'Toronto, ON',
    
    // CTA Section
    ctaTitle: 'Prêt à Découvrir des Événements Extraordinaires?',
    ctaDescription: 'Utilisez le bouton de commentaires dans l\'en-tête pour partager vos pensées et nous aider à améliorer votre expérience de découverte d\'événements.',
    ctaButton: 'Donner des Commentaires',
    
    // Quick Links Section
    quickLinksTitle: 'Liens Rapides',
    aboutUs: 'À Propos de Nous',
    ourServices: 'Nos Services',
    blogResources: 'Blog et Ressources',
    latestUpdates: 'Dernières mises à jour',
    careers: 'Carrières',
    helpCenter: 'Centre d\'Aide',
    contact: 'Contact',
    
    // Platform Section
    platformTitle: 'Plateforme',
    browseEvents: 'Parcourir les Événements',
    eventCalendar: 'Calendrier des Événements',
    advancedSearch: 'Recherche Avancée',
    apiDocumentation: 'Documentation API',
    mobileApp: 'Application Mobile',
    siteMap: 'Plan du Site',
    siteStatistics: 'Statistiques du Site',
    
    // Trust & Safety Section
    trustSafetyTitle: 'Confiance et Sécurité',
    securityCenter: 'Centre de Sécurité',
    accessibility: 'Accessibilité',
    communityGuidelines: 'Directives Communautaires',
    trustSafety: 'Confiance et Sécurité',
    reportIssue: 'Signaler un Problème',
    
    // Trust Badges
    sslSecured: 'SSL Sécurisé',
    iso27001: 'ISO 27001',
    gdprCompliant: 'Conforme RGPD',
    
    // Legal Links
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: 'Conditions de Service',
    cookiePolicy: 'Politique des Cookies',
    disclaimer: 'Avis de Non-Responsabilité',
    
    // Copyright
    copyright: '©',
    allRightsReserved: 'Tous droits réservés',
  },

  howItWorks: {
    title: 'Comment fonctionne Event Finder',
    subtitle: 'Découverte d\'événements alimentée par l\'IA à grande échelle',
    heroTitle: 'Event Finder : Découverte d\'événements alimentée par l\'IA à grande échelle',
    heroSubtitle: 'Découvrez comment nous utilisons une technologie IA de pointe pour trouver des événements sur des milliers de sites web dans le monde',
    
    challengeTitle: 'Le défi : Trouver une aiguille dans une botte de foin numérique',
    challengeDescription: 'Imaginez essayer de surveiller manuellement des milliers de sites web d\'événements à travers le globe pour découvrir les événements à venir, conférences, ateliers et sessions de formation. Chaque site web a des mises en page, des calendriers de mise à jour et des formats différents. Certains annoncent des événements des mois à l\'avance, d\'autres seulement quelques semaines. Manquer un seul événement important pourrait signifier perdre de précieuses opportunités d\'affaires.',
    
    solutionTitle: 'La solution alimentée par l\'IA : Découverte web intelligente',
    solutionDescription: 'Event Finder transforme cette tâche manuelle impossible en un système de découverte automatisé et intelligent qui fonctionne 24h/24 et 7j/7.',
    
    aiVisionTitle: '🧠 Système de vision IA double',
    aiVisionDescription: 'Le système emploie deux approches IA complémentaires pour s\'assurer qu\'aucun événement n\'échappe à la détection :',
    
    primaryMethodTitle: '1. Intelligence Markdown',
    primaryMethodSubtitle: 'Méthode principale',
    primaryMethodDescription: 'Notre approche principale convertit les sites web complexes en données structurées et propres pour l\'analyse IA.',
    primaryMethodFeatures: {
      webScraping: 'Extraction web avancée : Convertit les sites web HTML complexes en texte markdown structuré et propre',
      gptProcessing: 'Traitement GPT-4o-mini : Utilise les LLM récents d\'OpenAI pour comprendre et extraire les informations d\'événements du texte',
      contextUnderstanding: 'Compréhension du contexte : L\'IA ne cherche pas seulement des mots-clés—elle comprend le contexte, les dates, les lieux et les types d\'événements'
    },
    
    fallbackMethodTitle: '2. Analyse IA visuelle',
    fallbackMethodSubtitle: 'Méthode de secours',
    fallbackMethodDescription: 'Lorsque l\'analyse de texte n\'est pas suffisante, notre IA visuelle intervient pour interpréter le contenu web comme le ferait un humain.',
    fallbackMethodFeatures: {
      screenshotTechnology: 'Technologie de capture d\'écran : Capture des instantanés visuels de sites web en utilisant l\'automatisation Chrome',
      computerVision: 'Vision par ordinateur : Utilise GPT-4o avec des capacités de vision pour "voir" et interpréter le contenu web comme le ferait un humain',
      layoutIntelligence: 'Intelligence de mise en page : Reconnaît les listes d\'événements, calendriers et annonces peu importe la conception du site web'
    },
    
    smartMatchingTitle: '🎯 Correspondance intelligente d\'événements et déduplication',
    smartMatchingDescription: 'Le vrai pouvoir vient de la prévention de la surcharge d\'informations :',
    
    vectorSimilarityTitle: 'Correspondance de similarité vectorielle',
    vectorSimilarityFeatures: {
      semanticUnderstanding: 'Compréhension sémantique : Utilise des incorporations avancées pour comprendre qu\'"Atelier Azure" et "Formation Microsoft Cloud" pourraient être le même événement',
      intelligentDeduplication: 'Déduplication intelligente : Empêche le même événement d\'être enregistré plusieurs fois sur différents sites web d\'événements',
      confidenceScoring: 'Score de confiance : Chaque correspondance obtient un score de confiance, assurant la précision'
    },
    
    fuzzyLogicTitle: 'Traitement de logique floue',
    fuzzyLogicFeatures: {
      dateIntelligence: 'Intelligence de date : Comprend que "Mardi prochain" et "15 mars" pourraient faire référence à la même date',
      locationMatching: 'Correspondance de lieu : Reconnaît que "Seattle, WA" et "Seattle, Washington" sont le même endroit',
      titleVariations: 'Variations de titre : Capture les événements même lorsque les entreprises utilisent des noms légèrement différents'
    },
    
    processingPipelineTitle: '🔄 Pipeline de traitement intelligent',
    processingPipelineDescription: 'Le système fonctionne à travers une architecture sophistiquée basée sur les files d\'attente qui traite efficacement des milliers de sites web :',
    processingPipelineFeatures: {
      qualityControl: 'Contrôle qualité automatisé',
      freshnessFiltering: 'Filtrage de fraîcheur : Supprime automatiquement les événements de plus de 2 semaines pour garder les données actuelles',
      dataValidation: 'Validation des données : Assure que les informations d\'événements sont complètes et correctement formatées',
      errorRecovery: 'Récupération d\'erreur : Si une méthode échoue, le système essaie automatiquement des approches alternatives'
    },
    
    cloudArchitectureTitle: '🚀 Architecture cloud évolutive',
    cloudArchitectureDescription: 'Construit sur l\'infrastructure de qualité entreprise d\'Azure :',
    cloudArchitectureFeatures: {
      parallelProcessing: 'Traitement parallèle : Peut analyser des centaines de sites web simultanément',
      autoScaling: 'Mise à l\'échelle automatique : Ajuste automatiquement les ressources selon la charge de travail',
      faultTolerance: 'Tolérance aux pannes : Continue le traitement même si des sites web individuels sont en panne',
      globalReach: 'Portée mondiale : Traite les sites web du monde entier dans plusieurs fuseaux horaires'
    },
    
    resultsTitle: 'Les résultats incroyables',
    resultsDescription: 'Notre système alimenté par l\'IA offre une performance exceptionnelle et une valeur commerciale.',
    
    businessValueTitle: '💡 Valeur commerciale',
    businessValueForBD: 'Pour le développement d\'affaires : Ne ratez jamais d\'opportunités de partenariat, découvrez des événements conjoints et des possibilités de collaboration, obtenez de l\'intelligence concurrentielle et voyez les tendances de l\'industrie des mois à l\'avance.',
    businessValueForMarketing: 'Pour les équipes marketing : Trouvez des opportunités de contenu, des commandites d\'événements, des opportunités de prise de parole, des insights d\'audience et des événements de grande valeur pour la participation.',
    businessValueForSales: 'Pour les équipes de vente : Générez des prospects à partir des participants d\'événements, construisez des relations lors de rassemblements industriels et obtenez de l\'intelligence de marché sur les besoins des clients.',
    
    technologyStackTitle: 'La pile technologique : IA de première classe',
    azureOpenAITitle: '🤖 Intégration Azure OpenAI : GPT-4o et GPT-4o-mini pour la compréhension de contenu, modèles d\'incorporation de texte pour la similarité sémantique et capacités de vision pour le traitement de contenu visuel.',
    azureSearchTitle: '🔍 Azure AI Search : Recherche vectorielle pour trouver des événements similaires, recherche sémantique pour la compréhension d\'intention et indexation en temps réel de nouveaux événements.',
    analyticsTitle: '📊 Analytics complets : Application Insights pour la surveillance, tableaux de bord personnalisés pour le suivi des tendances et métriques de qualité pour mesurer la précision.',
    
    realWorldImpactTitle: 'Impact dans le monde réel',
    realWorldImpactDescription: 'Imaginez découvrir que trois de vos partenaires clés organisent des conférences IA le même mois, vous donnant des opportunités de coordonner le marketing, planifier des événements complémentaires, éviter les conflits et créer des partenariats. Ou trouver des tendances technologiques émergentes des semaines avant qu\'elles ne deviennent mainstream.',
    
    ctaTitle: 'Prêt à débloquer l\'intelligence cachée dans des milliers de sites web ?',
    ctaDescription: 'Les événements de demain sont planifiés aujourd\'hui—assurez-vous d\'être le premier à les connaître.',
    ctaButton: 'Explorer les événements maintenant'
  },

  regional: {
    currency: 'CAD',
    dateFormat: 'DD/MM/YYYY',
    timeFormat: '24-hour',
    numberFormat: '1 234,56',
    phoneFormat: '(555) 123-4567',
    addressFormat: 'Rue, Ville, Province Code Postal',
  },
};
